import { useCallback } from 'react';
import { payrollHistoryImportGateway } from '../index';
import { useAsyncData, type AsyncData } from './useAsyncData';
import type { Capabilities } from '../types';

/** Display-only gating: hides controls the server would reject anyway. The server remains the enforcer. */
export function useCapabilities(): AsyncData<Capabilities> {
  const load = useCallback((signal: AbortSignal) => payrollHistoryImportGateway.getCapabilities(signal), []);
  return useAsyncData(load);
}
